import { useEffect, useState } from 'react'

import CopyButton from './CopyButton'

import '../css/XmlBlock.css'
import SmallButton from './SmallButton'
import { FaAngleDown, FaAngleUp, FaMapMarkerAlt } from 'react-icons/fa'

const XmlBlock = ({
    xml,
    showOnMap,
    searchTerm,
}) => {
    const [expanded, setIsExpanded] = useState(false)
    const [regex, setRegex] = useState()
    const [xmlParts, setXmlParts] = useState()

    // When the search term or XML changes, force expand search matches, and
    // contract no matches.
    useEffect(() => {
        if (!searchTerm) {
            setRegex(undefined)
            setXmlParts(undefined)
            return
        }

        const newRegex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')

        setRegex(newRegex)
        setXmlParts(xml.split(newRegex))

        setIsExpanded(newRegex.test(xml))
    }, [searchTerm, xml])

    return <div className="XmlBlock">
        <pre className={expanded ? undefined : 'compact'}>
            {(searchTerm && regex && xmlParts)
                ? xmlParts.map((part, index) => {
                    return regex.test(part)
                        ? <mark key={index}>{part}</mark>
                        : part
                })
                : xml}
        </pre>
        <div className="buttons">
            {showOnMap && <SmallButton onClick={showOnMap}>
                <FaMapMarkerAlt />
            </SmallButton>}
            <CopyButton value={xml} />
            <SmallButton onClick={() => setIsExpanded(!expanded)}>
                {expanded
                    ? <FaAngleUp />
                    : <FaAngleDown />}
            </SmallButton>
        </div>
    </div>
}

export default XmlBlock
